/* ============================================================
   ECOBIKE — Color Dots v2 (uses native Impulse data-variant-image)
   ------------------------------------------------------------
   Impulse renders swatches as:
   <a class="color-swatch color-swatch--rot-schwarz color-swatch--with-image"
      data-variant-id="..." data-variant-image="//cdn.../red-01_400x.jpg">
   1. Set each dot background = data-variant-image (real frame cutout)
   2. Hover/click dot → swap product card main image to that variant color
   3. Click → preventDefault (no jump to PDP)
   ============================================================ */
(function () {
  'use strict';
  if (window.__ecobikeDotsV2) return;
  window.__ecobikeDotsV2 = true;

  function hiRes(url) {
    if (!url) return url;
    // Ensure protocol
    if (url.indexOf('//') === 0) url = 'https:' + url;
    // Upgrade _400x → _800x for the main image swap
    return url.replace(/_(\d+)x(\d*)\./, '_800x.');
  }

  function findCardImage(swatch) {
    // Walk up to the product card, then find its main image
    var card = swatch.closest('.grid-product, .grid__item, .product-card');
    if (!card) return null;
    return card.querySelector(
      '.grid-product__image, .grid-view-item__image, img.grid-product__image, ' +
      '.image-element img, .grid__image-ratio img, .image-wrap img, img'
    );
  }

  function processSwatch(swatch) {
    if (swatch.__ecobikeDot) return;
    swatch.__ecobikeDot = true;

    var raw = swatch.getAttribute('data-variant-image');
    if (!raw) return;
    var thumbUrl = (raw.indexOf('//') === 0 ? 'https:' + raw : raw);

    // 1. Dot background = real frame cutout (center, zoomed)
    swatch.style.backgroundImage = 'url(' + thumbUrl + ')';
    swatch.style.backgroundSize = '300%';
    swatch.style.backgroundPosition = '50% 52%';
    swatch.style.backgroundRepeat = 'no-repeat';
    swatch.classList.add('ecobike-dot-img');

    var mainImg = findCardImage(swatch);
    if (!mainImg) return;
    var swapUrl = hiRes(raw);

    function swap() {
      if (!mainImg.__ecobikeOrigSrc) {
        mainImg.__ecobikeOrigSrc = mainImg.currentSrc || mainImg.src;
        mainImg.__ecobikeOrigSrcset = mainImg.getAttribute('srcset');
      }
      mainImg.removeAttribute('srcset');
      mainImg.src = swapUrl;
    }
    function restore() {
      if (mainImg.__ecobikeOrigSrc && !swatch.__ecobikeLocked) {
        mainImg.src = mainImg.__ecobikeOrigSrc;
        if (mainImg.__ecobikeOrigSrcset) mainImg.setAttribute('srcset', mainImg.__ecobikeOrigSrcset);
      }
    }

    swatch.addEventListener('mouseenter', swap);
    swatch.addEventListener('mouseleave', restore);
    swatch.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      // Lock this color as the displayed one + unlock siblings
      var siblings = swatch.parentElement ? swatch.parentElement.querySelectorAll('.color-swatch') : [];
      for (var i = 0; i < siblings.length; i++) { siblings[i].__ecobikeLocked = false; siblings[i].classList.remove('is-active-dot'); }
      swatch.__ecobikeLocked = true;
      swatch.classList.add('is-active-dot');
      mainImg.__ecobikeOrigSrc = swapUrl;          // make this the new default
      mainImg.__ecobikeOrigSrcset = null;
      swap();
    }, true);
  }

  function processAll() {
    document.querySelectorAll('.color-swatch[data-variant-image]').forEach(processSwatch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAll);
  } else {
    processAll();
  }
  // Re-process after AJAX filter/sort/pagination
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes && muts[i].addedNodes.length) { processAll(); break; }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
